import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Product } from '../models/interfaces';

@Pipe({
  name: 'productNameFormatter',
  pure: false,
})
export class ProductNameFormatterPipe implements PipeTransform {
  constructor(private translateService: TranslateService) {}

  transform(product: Product, productId?: number): string {
    if (!productId && !product) {
      return '-';
    }

    if (!product) {
      return this.translateService.instant('pipes.text.deleted_service');
    }

    return product.name;
  }
}
